import { render, staticRenderFns } from "./stepDescription.vue?vue&type=template&id=2db92af6&scoped=true&"
import script from "./stepDescription.vue?vue&type=script&lang=js&"
export * from "./stepDescription.vue?vue&type=script&lang=js&"
import style0 from "./stepDescription.vue?vue&type=style&index=0&id=2db92af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db92af6",
  null
  
)

export default component.exports